import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const applyMalomoMigration = {
  name: "applyMalomoMigration" as const,
  input: z.object({
    teamId: zExt.objectId(),
    startDateOverride: z.string().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    error: z.string().optional(),
    carrierMappingsImported: z.number(),
    stalledSettingsImported: z.boolean(),
    integrationsCreated: z.array(z.string()),
    billingImported: z.boolean(),
    billingStartDateOmitted: z.boolean(),
  }),
};
